export enum MessageType {
    error,
    warning,
    info,
    success,
  };